import { Box, Text as ChakraText, Divider } from '@chakra-ui/react'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import type { AnalyticsAPIResponse } from '../../interfaces'
import { UserContext } from '../../providers'
import { TopAssets } from '../../components/Analytics'

interface Props {
  data: AnalyticsAPIResponse | null
  dateRange?: {
    startDate: Date
    endDate: Date
  }
}

const MediaUsageLayout = ({ data, dateRange }: Props): React.ReactElement => {
  const { t } = useTranslation()

  const { user } = useContext(UserContext)

  const isUserOnImagekitCDN = user?.clientIsOnImageKitCDN

  if (!data) {
    return <span>{t('loading', 'Loading...')}</span>
  }

  return (
    <Box padding="1.5rem">
      {isUserOnImagekitCDN &&
        <Box marginBottom="2.5rem">
          <ChakraText
            fontWeight="semibold"
            marginBottom="0.75rem"
            fontSize="16px"
          >
            {t('top_image_assets', 'Top image assets')}
          </ChakraText>
          <Divider />
          <TopAssets {...{ data, assetClass: "image", dateRange }} />
        </Box>
      }

      {isUserOnImagekitCDN &&
        <Box marginBottom="2.5rem">
          <ChakraText
            fontWeight="semibold"
            marginBottom="0.75rem"
            fontSize="16px"
          >
            {t('top_video_assets', 'Top video assets')}
          </ChakraText>
          <Divider />
          <TopAssets {...{ data, assetClass: "video" }} />
        </Box>
      }

      {isUserOnImagekitCDN &&
        <Box>
          <ChakraText
            fontWeight="semibold"
            marginBottom="0.75rem"
            fontSize="16px"
          >
            {t('top_other_assets', 'Top other assets')}
          </ChakraText>
          <Divider />
          <TopAssets {...{ data, assetClass: "others" }} />
        </Box>
      }
    </Box>
  )
}

export default MediaUsageLayout
